/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfReportCategory } from '../../models/data-page-of-report-category';

export interface ReportCategoryGet$Params {
  pageSize?: number;
  pageNumber?: number;
}

export function reportCategoryGet(http: HttpClient, rootUrl: string, params?: ReportCategoryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReportCategory>> {
  const rb = new RequestBuilder(rootUrl, reportCategoryGet.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfReportCategory>;
    })
  );
}

reportCategoryGet.PATH = '/api/ReportCategory/reportcategories/list';
